(function() {
	'use strict';

	angular.module('app.dashboard')
	.config(unableToFixValueParetoConfig);

	function unableToFixValueParetoConfig(dashboardProvider) {
		dashboardProvider.widget(
			'unableToFixValuePareto', {
				name: 'Unable to Fix Value Pareto',
				description: 'Shows the top Unable to Fix categories by inventory action value.',
				thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/unable-to-fix-value-pareto.jpg',
				categories: ['All', 'Inventory'],
				config: {},
				slideshowView: true,
				isActive: true,
				controller: 'unableToFixValueParetoCtrl',
				templateUrl: '/application/f/dashboard/widgets/unable-to-fix-value-pareto.html',
				reload: true,
				isDrillDown: true,
				isEditable: true,
				resolve: {
					pastTimePeriodValue: function (config) {
						if (config.pastTimePeriod) {
							return config.pastTimePeriod;
						}
						return 'all';
					}
				}
			}
		);
	}
})();
